import { render } from "./KnowhowCbt.vue?vue&type=template&id=d0ef1040&scoped=true"
import script from "./KnowhowCbt.vue?vue&type=script&lang=js"
export * from "./KnowhowCbt.vue?vue&type=script&lang=js"

import "./KnowhowCbt.vue?vue&type=style&index=0&id=d0ef1040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ef1040"]])

export default __exports__